import { T } from '@tribeplatform/react-components/i18n'

import { CommunityLanguage } from '../CommunityLanguage.js'

export function CommunityLanguageRouter() {
  return <CommunityLanguage />
}

export function CommunityLanguageBreadCrumb() {
  return (
    <T
      id="Localization.CommunityLanguage"
      defaultMessage="Community Language"
    />
  )
}
